module.exports = __webpack_public_path__ + "img/apparatus1.6df0277a.jpg";